// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F3T4F","badges":"styles_badges__1R5N8"};